import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Edit from 'appSrc/components/Icons/Edit';
import { FormTextField, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { dAPI } from 'appSrc/api';
import { debounce } from 'throttle-debounce';
import style from './styles/style.module.css';

class SettingForm extends PureComponent {

    constructor( props ) {
        super( props );
    }

    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }

    submitHandler = ( values ) => {
        var data = { ...values };
        this.props.onSubmit( { item: data} ); 
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <div>
                <Form className={ style.itemForm }
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id="value"
                            name="value"
                            label="Value"
                            component={ FormTextField }
                            fullWidth />
                            
                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

SettingForm.defaultProps = {
    initialValues: {},
};

SettingForm = reduxForm( {
    form: 'SettingForm',
} )( SettingForm );

const mapStateToProps = ( state ) => {
    return {};
};

const mapDispatchToProps = ( dispatch ) => {
    return {};
};

export default connect( mapStateToProps, mapDispatchToProps )( SettingForm );
